import { render, staticRenderFns } from "./WorksShow.vue?vue&type=template&id=776d5a7e&scoped=true&"
import script from "./WorksShow.vue?vue&type=script&lang=js&"
export * from "./WorksShow.vue?vue&type=script&lang=js&"
import style0 from "./WorksShow.vue?vue&type=style&index=0&id=776d5a7e&prod&lang=less&scoped=true&"
import style1 from "./WorksShow.vue?vue&type=style&index=1&id=776d5a7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d5a7e",
  null
  
)

export default component.exports